"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var AffilateLanguageEditor_1 = require("./config/language/AffilateLanguageEditor");
var AffilateLanguagesList_1 = require("./config/language/AffilateLanguagesList");
var AffilateCurrencyEditor_1 = require("./config/currency/AffilateCurrencyEditor");
var AffilateCurrencyList_1 = require("./config/currency/AffilateCurrencyList");
var AffilateBrandsList_1 = require("./config/brands/AffilateBrandsList");
var AffilateBrandEditor_1 = require("./config/brands/AffilateBrandEditor");
var AffilateOffersList_1 = require("./config/offers/AffilateOffersList");
var AffilateOfferEditor_1 = require("./config/offers/AffilateOfferEditor");
var AffilatePayoutList_1 = require("./config/payout/AffilatePayoutList");
var AffilatePayoutEditor_1 = require("./config/payout/AffilatePayoutEditor");
var AffilateCountryList_1 = require("./config/country/AffilateCountryList");
var AffilateCountryEditor_1 = require("./config/country/AffilateCountryEditor");
var AffilatePromoCodesTemplatesList_1 = require("./config/promo_codes_templates/AffilatePromoCodesTemplatesList");
var AffilatePromoCodeTemplateEditor_1 = require("./config/promo_codes_templates/AffilatePromoCodeTemplateEditor");
var AffilateEmailTemplatesList_1 = require("./config/email/AffilateEmailTemplatesList");
var AffilateEmailTemplateEditor_1 = require("./config/email/AffilateEmailTemplateEditor");
var AffilateEmailTemplateOperations_1 = require("./config/email/AffilateEmailTemplateOperations");
var AffilateConfig = /** @class */ (function (_super) {
    __extends(AffilateConfig, _super);
    function AffilateConfig(props) {
        var _this = _super.call(this, props) || this;
        _this.tab_opt_currency = "opt.currency";
        _this.tab_opt_language = "opt.language";
        _this.tab_opt_brand = "opt.brand";
        _this.tab_opt_offer = "opt.offer";
        _this.tab_opt_country = "opt.country";
        _this.tab_opt_payouts = "opt.payouts";
        _this.tab_opt_promo_templates = "opt.promo.templates";
        _this.tab_opt_email = "opt.email";
        return _this;
    }
    AffilateConfig.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AC = this.props.listAvailAppCurrency.Subscribe("*", function (id, data) {
            _this.setState({ availCurrency: data.data });
        });
        this.SID_AL = this.props.listAvailAppLanguages.Subscribe("*", function (id, data) {
            _this.setState({ availLanguage: data.data });
        });
        this.SID_AB = this.props.listAvailBrands.Subscribe("*", function (id, data) {
            _this.setState({ availBrands: data.data });
        });
        this.SID_AG = this.props.listAvailAppCountry.Subscribe("*", function (id, data) {
            _this.setState({ availCountry: data.data });
        });
        this.SID_AP = this.props.listAvailAppPayout.Subscribe("*", function (id, data) {
            _this.setState({ availPayouts: data.data });
        });
        this.setState({
            APPAffilateCurrencyMode: "LIST",
            AppAffilateCurrencyRecord: null,
            APPAffilateLanguageMode: "LIST",
            AppAffilateLanguageRecord: null,
            APPAffilateBrandMode: "LIST",
            AppAffilateBrandRecord: null,
            APPAffilateOfferMode: "LIST",
            AppAffilateOfferRecord: null,
            APPAffilateCountryMode: "LIST",
            AppAffilateCountryRecord: null,
            APPAffilatePayoutMode: "LIST",
            AppAffilatePayoutRecord: null,
            APPAffilatePromoCodeTemplateMode: "LIST",
            AppAffilatePromoCodeTemplateRecord: null,
            APPAffilateEmailMode: "LIST",
            APPAffilateEmailRecord: null,
            email_tpl_base64_content: "",
            email_json_base64_content: "",
            availCurrency: [],
            availLanguage: [],
            availBrands: [],
            availCountry: [],
            availPayouts: []
        }, function () {
            _this.props.listAvailAppCurrency.LoadData();
            _this.props.listAvailAppLanguages.LoadData();
            _this.props.listAvailBrands.LoadData();
            _this.props.listAvailAppCountry.LoadData();
            _this.props.listAvailAppPayout.LoadData();
        });
        this.props.state.setExtBreadCrumbPath(["Настройки П.Программы"]);
    };
    AffilateConfig.prototype.componentWillUnmount = function () {
        this.props.listAvailAppCurrency.UnSubscribe(this.SID_AC);
        this.props.listAvailAppLanguages.UnSubscribe(this.SID_AL);
        this.props.listAvailBrands.UnSubscribe(this.SID_AB);
        this.props.listAvailAppCountry.UnSubscribe(this.SID_AG);
        this.props.listAvailAppPayout.UnSubscribe(this.SID_AP);
    };
    AffilateConfig.prototype.backToRootClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    AffilateConfig.prototype.newAppCurrencyClick = function () {
        this.setState({ APPAffilateCurrencyMode: "NEW", AppAffilateCurrencyRecord: null });
    };
    AffilateConfig.prototype.editAppCurrencyClick = function (record) {
        this.setState({ APPAffilateCurrencyMode: "EDIT", AppAffilateCurrencyRecord: record });
    };
    AffilateConfig.prototype.backToAppCurrencyListClick = function () {
        this.setState({ APPAffilateCurrencyMode: "LIST", AppAffilateCurrencyRecord: null });
    };
    AffilateConfig.prototype.getAPPCurrencyObject = function () {
        if (this.state.APPAffilateCurrencyMode === "LIST") {
            return (React.createElement(AffilateCurrencyList_1.default, { state: this.props.state, data: this.props.listAffilateCurrency, onGoBackClick: this.backToRootClick.bind(this), onCreateClick: this.newAppCurrencyClick.bind(this), onEditClick: this.editAppCurrencyClick.bind(this), rootRecord: this.props.record }));
        }
        if (this.state.APPAffilateCurrencyMode === "NEW") {
            return (React.createElement(AffilateCurrencyEditor_1.default, { data: this.props.listAffilateCurrency, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToAppCurrencyListClick.bind(this), availCurrency: this.state.availCurrency }));
        }
        if (this.state.APPAffilateCurrencyMode === "EDIT") {
            return (React.createElement(AffilateCurrencyEditor_1.default, { data: this.props.listAffilateCurrency, record: this.state.AppAffilateCurrencyRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToAppCurrencyListClick.bind(this), availCurrency: this.state.availCurrency }));
        }
        throw "No available render for aff currency active edit mode -> " + this.state.APPAffilateCurrencyMode;
    };
    AffilateConfig.prototype.newBrandClick = function () {
        this.setState({ APPAffilateBrandMode: "NEW", AppAffilateBrandRecord: null });
    };
    AffilateConfig.prototype.editBrandClick = function (record) {
        this.setState({ APPAffilateBrandMode: "EDIT", AppAffilateBrandRecord: record });
    };
    AffilateConfig.prototype.backToBrandsListClick = function () {
        this.setState({ APPAffilateBrandMode: "LIST", AppAffilateBrandRecord: null });
    };
    AffilateConfig.prototype.getBrandObject = function () {
        if (this.state.APPAffilateBrandMode === "LIST") {
            return (React.createElement(AffilateBrandsList_1.default, { state: this.props.state, data: this.props.listAffilateBrands, onGoBackClick: this.backToRootClick.bind(this), onCreateClick: this.newBrandClick.bind(this), onEditClick: this.editBrandClick.bind(this), rootRecord: this.props.record }));
        }
        if (this.state.APPAffilateBrandMode === "NEW") {
            return (React.createElement(AffilateBrandEditor_1.default, { data: this.props.listAffilateBrands, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToBrandsListClick.bind(this), availBrands: this.state.availBrands }));
        }
        if (this.state.APPAffilateBrandMode === "EDIT") {
            return (React.createElement(AffilateBrandEditor_1.default, { data: this.props.listAffilateBrands, record: this.state.AppAffilateBrandRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToBrandsListClick.bind(this), availBrands: this.state.availBrands }));
        }
        throw "No available render for aff brand active edit mode -> " + this.state.APPAffilateBrandMode;
    };
    AffilateConfig.prototype.newOfferClick = function () {
        this.setState({ APPAffilateOfferMode: "NEW", AppAffilateOfferRecord: null });
    };
    AffilateConfig.prototype.editOfferClick = function (record) {
        this.setState({ APPAffilateOfferMode: "EDIT", AppAffilateOfferRecord: record });
    };
    AffilateConfig.prototype.backToOffersListClick = function () {
        this.setState({ APPAffilateOfferMode: "LIST", AppAffilateOfferRecord: null });
    };
    AffilateConfig.prototype.getOfferObject = function () {
        if (this.state.APPAffilateOfferMode === "LIST") {
            return (React.createElement(AffilateOffersList_1.default, { state: this.props.state, data: this.props.listAffilateOffers, onGoBackClick: this.backToRootClick.bind(this), onCreateClick: this.newOfferClick.bind(this), onEditClick: this.editOfferClick.bind(this), rootRecord: this.props.record }));
        }
        if (this.state.APPAffilateOfferMode === "NEW") {
            return (React.createElement(AffilateOfferEditor_1.default, { data: this.props.listAffilateOffers, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToOffersListClick.bind(this), offersList: this.props.listAvailAffilateOffers }));
        }
        if (this.state.APPAffilateOfferMode === "EDIT") {
            return (React.createElement(AffilateOfferEditor_1.default, { data: this.props.listAffilateOffers, record: this.state.AppAffilateOfferRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToOffersListClick.bind(this), offersList: this.props.listAvailAffilateOffers }));
        }
        throw "No available render for aff offer active edit mode -> " + this.state.APPAffilateOfferMode;
    };
    AffilateConfig.prototype.newAppLanguageClick = function () {
        this.setState({ APPAffilateLanguageMode: "NEW", AppAffilateLanguageRecord: null });
    };
    AffilateConfig.prototype.editAppLanguageClick = function (record) {
        this.setState({ APPAffilateLanguageMode: "EDIT", AppAffilateLanguageRecord: record });
    };
    AffilateConfig.prototype.backToAppLanguageListClick = function () {
        this.setState({ APPAffilateLanguageMode: "LIST", AppAffilateLanguageRecord: null });
    };
    AffilateConfig.prototype.getAPPLanguageObject = function () {
        if (this.state.APPAffilateLanguageMode === "LIST") {
            return (React.createElement(AffilateLanguagesList_1.default, { state: this.props.state, data: this.props.listAffilateLanguage, onGoBackClick: this.backToRootClick.bind(this), onCreateClick: this.newAppLanguageClick.bind(this), onEditClick: this.editAppLanguageClick.bind(this), rootRecord: this.props.record }));
        }
        if (this.state.APPAffilateLanguageMode === "NEW") {
            return (React.createElement(AffilateLanguageEditor_1.default, { data: this.props.listAffilateLanguage, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToAppLanguageListClick.bind(this), availLanguage: this.state.availLanguage }));
        }
        if (this.state.APPAffilateLanguageMode === "EDIT") {
            return (React.createElement(AffilateLanguageEditor_1.default, { data: this.props.listAffilateLanguage, record: this.state.AppAffilateLanguageRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToAppLanguageListClick.bind(this), availLanguage: this.state.availLanguage }));
        }
        throw "No available render for aff language active edit mode -> " + this.state.APPAffilateLanguageMode;
    };
    AffilateConfig.prototype.newAppPayoutClick = function () {
        this.setState({ APPAffilatePayoutMode: "NEW", AppAffilatePayoutRecord: null });
    };
    AffilateConfig.prototype.editAppPayoutClick = function (record) {
        this.setState({ APPAffilatePayoutMode: "EDIT", AppAffilatePayoutRecord: record });
    };
    AffilateConfig.prototype.backToAppPayoutListClick = function () {
        this.setState({ APPAffilatePayoutMode: "LIST", AppAffilatePayoutRecord: null });
    };
    AffilateConfig.prototype.getAPPPayoutObject = function () {
        if (this.state.APPAffilatePayoutMode === "LIST") {
            return (React.createElement(AffilatePayoutList_1.default, { state: this.props.state, data: this.props.listAffilatePayouts, onGoBackClick: this.backToRootClick.bind(this), onCreateClick: this.newAppPayoutClick.bind(this), onEditClick: this.editAppPayoutClick.bind(this), rootRecord: this.props.record }));
        }
        if (this.state.APPAffilatePayoutMode === "NEW") {
            return (React.createElement(AffilatePayoutEditor_1.default, { data: this.props.listAffilatePayouts, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToAppPayoutListClick.bind(this), availPayouts: this.state.availPayouts }));
        }
        if (this.state.APPAffilatePayoutMode === "EDIT") {
            return (React.createElement(AffilatePayoutEditor_1.default, { data: this.props.listAffilatePayouts, record: this.state.AppAffilatePayoutRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToAppPayoutListClick.bind(this), availPayouts: this.state.availPayouts }));
        }
        throw "No available render for aff payout active edit mode -> " + this.state.APPAffilatePayoutMode;
    };
    AffilateConfig.prototype.newAppCountryClick = function () {
        this.setState({ APPAffilateCountryMode: "NEW", AppAffilateCountryRecord: null });
    };
    AffilateConfig.prototype.editAppCountryClick = function (record) {
        this.setState({ APPAffilateCountryMode: "EDIT", AppAffilateCountryRecord: record });
    };
    AffilateConfig.prototype.backToAppCountryListClick = function () {
        this.setState({ APPAffilateCountryMode: "LIST", AppAffilateCountryRecord: null });
    };
    AffilateConfig.prototype.getAPPCountryObject = function () {
        if (this.state.APPAffilateCountryMode === "LIST") {
            return (React.createElement(AffilateCountryList_1.default, { state: this.props.state, data: this.props.listAffilateCountry, onGoBackClick: this.backToRootClick.bind(this), onCreateClick: this.newAppCountryClick.bind(this), onEditClick: this.editAppCountryClick.bind(this), rootRecord: this.props.record }));
        }
        if (this.state.APPAffilateCountryMode === "NEW") {
            return (React.createElement(AffilateCountryEditor_1.default, { data: this.props.listAffilateCountry, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToAppCountryListClick.bind(this), availCountry: this.state.availCountry }));
        }
        if (this.state.APPAffilateCountryMode === "EDIT") {
            return (React.createElement(AffilateCountryEditor_1.default, { data: this.props.listAffilateCountry, record: this.state.AppAffilateCountryRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToAppCountryListClick.bind(this), availCountry: this.state.availCountry }));
        }
        throw "No available render for aff country active edit mode -> " + this.state.APPAffilateCountryMode;
    };
    /*
    APPAffilatePromoCodeTemplateMode: "LIST" | "EDIT" | "NEW";
    AppAffilatePromoCodeTemplateRecord: IAffilatePromoCodeTemplateItem;
    */
    AffilateConfig.prototype.newPromoTemplateObjectClick = function () {
        this.setState({ APPAffilatePromoCodeTemplateMode: "NEW", AppAffilatePromoCodeTemplateRecord: null });
    };
    AffilateConfig.prototype.editPromoTemplateObjectClick = function (record) {
        this.setState({ APPAffilatePromoCodeTemplateMode: "EDIT", AppAffilatePromoCodeTemplateRecord: record });
    };
    AffilateConfig.prototype.backToPromoTemplatesListClick = function () {
        this.setState({ APPAffilatePromoCodeTemplateMode: "LIST", AppAffilatePromoCodeTemplateRecord: null });
    };
    AffilateConfig.prototype.getPromoTemplateObject = function () {
        if (this.state.APPAffilatePromoCodeTemplateMode === "LIST") {
            return (React.createElement(AffilatePromoCodesTemplatesList_1.default, { state: this.props.state, data: this.props.promoData, onGoBackClick: this.backToRootClick.bind(this), onCreateClick: this.newPromoTemplateObjectClick.bind(this), onEditClick: this.editPromoTemplateObjectClick.bind(this), rootRecord: this.props.record }));
        }
        if (this.state.APPAffilatePromoCodeTemplateMode === "NEW") {
            return (React.createElement(AffilatePromoCodeTemplateEditor_1.default, { data: this.props.promoData, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToPromoTemplatesListClick.bind(this), brandsList: this.props.brandsList, promoForBrandsList: this.props.promoForBrandsList }));
        }
        if (this.state.APPAffilatePromoCodeTemplateMode === "EDIT") {
            return (React.createElement(AffilatePromoCodeTemplateEditor_1.default, { data: this.props.promoData, record: this.state.AppAffilatePromoCodeTemplateRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToPromoTemplatesListClick.bind(this), brandsList: this.props.brandsList, promoForBrandsList: this.props.promoForBrandsList }));
        }
        throw "No available render for promo template objects active edit mode -> " + this.state.APPAffilatePromoCodeTemplateMode;
    };
    AffilateConfig.prototype.newEmailTemplateClick = function () {
        this.setState({ APPAffilateEmailMode: "NEW", APPAffilateEmailRecord: null });
    };
    AffilateConfig.prototype.editEmailTemplateClick = function (record) {
        this.setState({ APPAffilateEmailMode: "EDIT", APPAffilateEmailRecord: record });
    };
    AffilateConfig.prototype.operationsEmailTemplateClick = function (record) {
        var _this = this;
        this.props.affilateEmailTemplates.GetGwsEmailTemplateContent(record.key, function (TplBase64, JsonBase64) {
            _this.setState({
                APPAffilateEmailMode: "OPERATIONS",
                email_tpl_base64_content: TplBase64,
                email_json_base64_content: JsonBase64,
                APPAffilateEmailRecord: record
            });
        });
    };
    AffilateConfig.prototype.backToEmailListClick = function () {
        this.setState({ APPAffilateEmailMode: "LIST", APPAffilateEmailRecord: null });
    };
    AffilateConfig.prototype.getEmailTemplateObject = function () {
        if (this.state.APPAffilateEmailMode === "LIST") {
            return (React.createElement(AffilateEmailTemplatesList_1.default, { state: this.props.state, data: this.props.affilateEmailTemplates, onGoBack: this.backToRootClick.bind(this), onNewClick: this.newEmailTemplateClick.bind(this), onEditClick: this.editEmailTemplateClick.bind(this), rootRecord: this.props.record, onTemplateOperationClick: this.operationsEmailTemplateClick.bind(this) }));
        }
        if (this.state.APPAffilateEmailMode === "NEW") {
            return (React.createElement(AffilateEmailTemplateEditor_1.default, { data: this.props.affilateEmailTemplates, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToEmailListClick.bind(this), listEMailTemplateActions: this.props.listAvailEMailTemplateActions, langsAvail: this.props.listAvailAppLanguages }));
        }
        if (this.state.APPAffilateEmailMode === "EDIT") {
            return (React.createElement(AffilateEmailTemplateEditor_1.default, { data: this.props.affilateEmailTemplates, record: this.state.APPAffilateEmailRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToEmailListClick.bind(this), listEMailTemplateActions: this.props.listAvailEMailTemplateActions, langsAvail: this.props.listAvailAppLanguages }));
        }
        if (this.state.APPAffilateEmailMode === "OPERATIONS") {
            return (React.createElement(AffilateEmailTemplateOperations_1.default, { dataTemplates: this.props.affilateEmailTemplates, dataImages: this.props.affilateEmailTemplateImages, record: this.state.APPAffilateEmailRecord, state: this.props.state, dialogSelectImage: this.props.dialogSelectImage, onGoBackClick: this.backToEmailListClick.bind(this), TPLBase64: this.state.email_tpl_base64_content, JSONBase64: this.state.email_json_base64_content }));
        }
        throw "No available render for active edit email mode -> " + this.state.APPAffilateEmailMode;
    };
    AffilateConfig.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(antd_1.Tabs, { defaultActiveKey: this.tab_opt_currency },
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "donate" }),
                        "\u0412\u0430\u043B\u044E\u0442\u044B"), key: this.tab_opt_currency }, this.getAPPCurrencyObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "language" }),
                        "\u041B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438"), key: this.tab_opt_language }, this.getAPPLanguageObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "globe" }),
                        "\u0421\u0442\u0440\u0430\u043D\u044B"), key: this.tab_opt_country }, this.getAPPCountryObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "credit-card" }),
                        "\u0412\u044B\u043F\u043B\u0430\u0442\u044B"), key: this.tab_opt_payouts }, this.getAPPPayoutObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "registered" }),
                        "\u0411\u0440\u0435\u043D\u0434\u044B"), key: this.tab_opt_brand }, this.getBrandObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "percent" }),
                        "\u041E\u0444\u0444\u0435\u0440\u044B \u043F\u043E-\u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E"), key: this.tab_opt_offer }, this.getOfferObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "gift" }),
                        "\u0428\u0430\u0431\u043B\u043E\u043D\u044B \u043F\u0440\u043E\u043C\u043E \u043F\u043E-\u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E"), key: this.tab_opt_promo_templates }, this.getPromoTemplateObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "envelope" }),
                        "EMail"), key: this.tab_opt_email }, this.getEmailTemplateObject()))));
    };
    return AffilateConfig;
}(React.Component));
exports.default = AffilateConfig;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ui/component/AffilateConfig.tsx
// module id = 2015
// module chunks = 0